import {useSelector} from 'react-redux'
import {PageSubTitle, PageTitle, ResponsivePageTitle} from '../../core/title'
import classNames from 'classnames'

const ContentHeader = ({section, title, children}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    return <>
        <ResponsivePageTitle />
        <div className="content-title">
            <div className="left-side">
                <div>
                    {section && <PageSubTitle>
                        <p className={classNames('section', {dark: isDarkMode})}>
                            {section}
                        </p>
                    </PageSubTitle>}
                    {title && <PageTitle>
                        <h1 className={classNames('page-title', {dark: isDarkMode})}>
                            {title}
                        </h1>
                    </PageTitle>}
                </div>
            </div>
            {children}
        </div>
    </>
}

export default ContentHeader
